<template>
    <div>
      <el-dialog :visible="visible" title="草稿箱" width="960px" :before-close="handleClose">
        <div class="search-box">
          <el-form ref="formSearch" :inline="true" :model="form" label-width="100px">
          <el-form-item label="草稿内容:">
            <el-input size="small" v-model="form.content" placeholder="请输入活动主题/短信内容"></el-input>
          </el-form-item>
            <el-form-item label="短信类型：">
              <el-select size="small" v-model="form.smsType">
                <el-option
                  v-for="(item, index) in smsTypeList"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>    
            <div class="button-group">
              <el-button size="small" class="search" type="primary"  @click="submitForm()"> 
                    <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;"></i> 查询
                </el-button>
                <el-button size="small" class="reset" type="primary"  @click="resetForm">重置</el-button>
            </div>
          </el-form>
        <div>
            <el-button  class="biaoqian_button2" style="margin-bottom: 10px"  :disabled="synchLoading" v-loading="synchLoading"
            @click="delPrecisionTask()">批量删除</el-button>
            <span class="delect_tips">*仅保留近一年的草稿数据</span>
        </div>
        <div class="table-box">
            <el-table ref="table" v-loading="tableLoading" :data="tableData" tooltip-effect="light" 
            style="width: 100%; border: 1px solid #eee"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            height="400"
            :cell-style="{'text-align':'left'}"
            @selection-change="handleSelectionChange">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column type="selection" align="center"> </el-table-column>
            <el-table-column label="短信类型" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.smsType == 0">普通短信</span>
              <span v-else-if="scope.row.smsType == 1">富信</span>
              <span v-else-if="scope.row.smsType == 2">卡片短信</span>
            </template>
            </el-table-column>
            <el-table-column label="活动主题" prop="activityTitle" min-width="120px"></el-table-column>
            <el-table-column key="content" label="短信内容" min-width="120px" prop="content">
              <template slot="header" slot-scope="scope">
                  <span>短信内容</span>
                  <span v-if="!allShow" :style="{ color: globalBG }" @click="
                    allShow = true;
                  doLayout();
                                                                                                                    "
                    class="table-message">(展开全部)</span>
                  <span v-if="allShow" :style="{ color: globalBG }" @click="
                    allShow = false;
                  doLayout();
                                                                                                                    "
                    class="table-message">(单行显示)</span>
                </template>
              <template slot-scope="scope">
              <div>
                <el-tooltip class="item" effect="light" :content="scope.row.smsType == 0 ? scope.row.content : scope.row.mediaTitle" placement="top">
                  <div class="hoveTitle" v-show="!allShow">
                    <span v-if="scope.row.smsType == 1" class="rich_title" @click="showMediaInfo(scope.row)">{{ scope.row.mediaTitle }}</span>
                    <span v-else-if="scope.row.smsType == 2" class="rich_title" @click="showCardInfo(scope.row)">{{ scope.row.mediaTitle }}</span>
                    <span v-else>{{ scope.row.content }}</span>
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow">
                  <span v-if="scope.row.smsType == 1" class="rich_title" @click="showMediaInfo(scope.row)">{{ scope.row.mediaTitle }}</span>
                  <span v-else-if="scope.row.smsType == 2" class="rich_title" @click="showCardInfo(scope.row)">{{ scope.row.mediaTitle }}</span>
                  <span v-else>{{ scope.row.content }}</span>
                </div>
              </div>
            </template>
            </el-table-column>
            <el-table-column label="最后一次保存时间" prop="updateTime" :min-width="'100px'"></el-table-column>
            <el-table-column label="操作" fixed="right" >
            <template slot-scope="scope">
              <div>
                <el-button type="text" style="width: 30px" class="operation" @click="editBtn(scope.row)">编辑</el-button>
                <el-button type="text" style="width: 30px" class="operation" @click="delectBtn(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
            </el-table>
            <div>
            <!-- 分页器 -->
            <el-pagination
            background
            style="text-align: right; margin-top: 20px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.current"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="form.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            ></el-pagination>
            </div>
        </div>
        </div>
      </el-dialog>

    <!-- 富信模板 -->
    <sms-info 
      v-if="smsInfoShow" 
      @close="smsInfoShow = false" 
      :isShow="smsInfoShow" 
      :mediaListJsonArray="mediaListJsonArray"
      :title="smsInfoTitle"
      :text="smsInfoText"
    />
    <sms-info-card 
      v-if="smsInfoCardShow"
      :isShow="smsInfoCardShow"
      :id="smsInfoCardId"
      @close="smsInfoCardShow = false" 
    ></sms-info-card>

    </div>
</template>
  
<script>
  import { mapState } from "vuex";
  import { getDraftList, deleteList} from "@/api/marketing/precisionMarketing";
  import smsInfo from '@/components/sms-info'
  import smsInfoCard from '@/components/sms-info-card'
  export default {
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
    },
    components: {
      smsInfo,
      smsInfoCard
    },
    data() {
        return{
          smsInfoCardShow: false, // 
          smsInfoCardId: "", // 
            visible:this.isShow,
            form: {
                // 官方查询的
                content:"",
                smsType:"",
                // 官方 end
                size: 10,
                current: 1,
            },
            smsTypeList: [
                {
                label: "全部",
                value: "",
                },
                {
                label: "普通短信",
                value: 0,
                },
                {
                label: "富信",
                value: 1,
                },
                {
                label: "卡片短信",
                value: 2,
                },
            ],
            tableData: [],
            total: 0,
            tableLoading: false,
            delList:[],
            synchLoading: false,
            allShow:false,
            smsInfoShow:false,//富信
            mediaListJsonArray:{},
        };
    },
    computed: {
      ...mapState({
        globalBG: "globalBG",
        //   把city映射给currentCIty
      }),
    },
    mounted() {
      this.getDataList()
    },
    methods: {
        //获取草稿列表
        getDataList(){
          this.tableLoading=true
          console.log("获取草稿列表",this.form)
          getDraftList(this.form).then((res) => {
            console.log("res",res)
            if (res.code == "1") {
              this.tableLoading=false
              this.tableData = res.data.records
              this.total = res.data.total
              this.form.current = res.data.current
            } else {
              this.tableLoading =false
              this.$message.error(res.message);
            }
          })
        },
        //多选
        handleSelectionChange(val) {
          this.delList = val || []
          console.log("多选",this.delList);
        },
        // 展开更多
        doLayout() {
          var that = this;
          this.$nextTick(() => {
            that.$refs.table.doLayout();
            var tableBox = that.$refs.table.$vnode.elm;
            var tbody = tableBox.getElementsByTagName("tbody");
            var tableTbody = tbody[0];
            var fixedTbody = tbody[1];
            var tableTrs = tableTbody.getElementsByTagName("tr");
            var fixedTrs = fixedTbody.getElementsByTagName("tr");

            for (var i = 0; i < tableTrs.length; i++) {
              fixedTrs[i].style.height = tableTrs[i].offsetHeight + "px";
            }
          });
        },
        editBtn(row){
          this.$emit("editData", row);
        },
       //删除
        delectBtn(id){
            let _delList = []
            _delList.push(id)
            console.log("id",_delList)

            this.$confirm("数据删除后不可恢复，是否确定删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            iconClass:"iconfont iconicon-jinggao1",
            }).then(() => {
              deleteList(_delList).then(res => {
                console.log("删除单个",res)
                if (res.code == "1") {
                  this.$message.success("删除成功!");
                  this.getDataList();
                } else {
                  this.$message.error(res.message);
                }

                });

            })
            .catch(() => {
                this.$message.info("已取消删除");
            });
           
        },
        //批量删除
        delPrecisionTask(){
          if (this.delList.length > 0) {
            let title = "已选择"+this.delList.length +"条数据,是否确定删除?"
            this.$confirm(title, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            iconClass:"iconfont iconicon-jinggao1",
            }).then(() => {
              let _delList = []
              this.delList.forEach(item=>{
                _delList.push(item.id)
              })
              deleteList(_delList).then(res => {
                  console.log("删除多个",res)
                  if (res.code == "1") {
                    this.$message.success("删除成功!");
                    this.getDataList();
                  } else {
                    this.$message.error(res.message);
                  }
                });
            })
            .catch(() => {
                this.$message.info("已取消删除");
            });
            } else {
                this.$message.warning("你未勾选数据，请勾选后删除");
            }
        },
        //显示更多
        showMediaInfo(row) {
          this.smsInfoShow = true
          this.mediaListJsonArray = JSON.parse(row.mediaListJsonArray)
          this.smsInfoTitle = row.mediaTitle
          this.smsInfoText = row.content
        },
        showCardInfo(row){
          this.smsInfoCardShow = true
          this.smsInfoCardId = row.mediaTemplateId
        },
        //提交查询
        submitForm(){
            this.getDataList();
        },
        // 重置
        resetForm() {
            this.form = {
                current: 1,
                size: 10,
                content:"",
                smsType:""
            };
            this.getDataList();
        },
        //关闭
        handleClose() {
            this.$emit("close", false);
        },
        handleSizeChange(size) {
            this.form.size = size;
            this.getDataList();
        },
        handleCurrentChange(current) {
            this.form.current = current;
            this.getDataList();
        },
    }
  }
  </script>
  
<style lang="scss" scoped>
.search-box{
    .button-group{
        display: inline-block;
        margin-left: 20px;
    }
    /deep/ .el-table th.is-leaf {
        height: 50px;
    }

    /deep/ .el-table th>.cell {
        height: 40px !important;
        line-height: 39px !important;
        font-size: 14px;
        font-family: Microsoft YaHei;
        -webkit-font-smoothing: antialiased;
        color: #333;
    }

    .table-message {
        color: #7f85e9 !important;
        cursor: pointer;
    }
    .button-group {
        text-align: center;
        // display: inline-block;
        margin-bottom: 20px;
        .search{
        width: 98px;
        height: 32px;
        color: #fe4d45;
        border: 1px solid #fe4d45 ;
        background-color: #fff;
        &:hover{
            color: #fff ;
            border: 1px solid #fff;
            background-color: #fe4d45;
            }
        }.reset{
            width: 98px;
            height: 32px;
            color: #666666;
            border: 1px solid #dddddd;
            background-color: #fff;
            &:hover{
            color:#fe4d45 ;
            border: 1px solid #fe4d45;
            background-color: #FFF4F4;
            }
        }
    }
    .biaoqian_button2 {
        width: 98px;
        height: 32px;
        color: #666666;
        border-radius: 3px;
        border: 1px solid #dddddd;
        background-color: #fff;

        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }

        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
    .delect_tips{
    color: #7f85e9;
    margin: 0 10px;
    }


.rich_title {
  color: #7f85e9;
  font-size: 14px;
  cursor: pointer;
}

 }
.operation {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.hoveTitleShowMore{
  text-align: left;
}
.el-message-box__content {
    padding: 20px 0px !important;
  }
</style>
  